import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import config, { configError } from './config';
import applyBranding from './branding';
import tenantGuard from './tenantGuard';
import ConfigError from './Components/ConfigError';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (configError) {
    // Sin config válida no se arranca: es mejor una pantalla de error que
    // mostrar los datos de un APR bajo el nombre y logo de otro.
    console.error('[config]', configError);
    root.render(<ConfigError message={configError} />);
} else {
    // Antes de renderizar: si el origen cambió de tenant (eid distinto al
    // último visto), purga sesión y biometría del APR anterior. Debe correr
    // antes de root.render porque Login.jsx lee localStorage al montar.
    tenantGuard(config);
    applyBranding(config);
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
    reportWebVitals();
}
